import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import {
  Router,
  NavigationEnd
} from '@angular/router';
import { WindowService } from '@core/window.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration.service';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environment';


@Component({
  selector: 'app-web',
  styleUrls: ['app.component.scss'],
  template: '<router-outlet></router-outlet>',
  })
export class AppComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    protected windowRef: WindowService,
    protected translate: TranslateService,
    protected config: ConfigurationService,
    private renderer: Renderer2,
  ) {
    this.translate.setDefaultLang('pt-BR');
    this.translate.use('pt-BR');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
      }
    });
  }

  ngOnInit() {
    const config = this.config.getConfig();
    this.loadStyle(config.style);
    this.loadGoogleAnalytics()
  }

  protected loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;
      head.appendChild(style);
    }
  }

  private loadGoogleAnalytics(): void {
    const script1 = this.renderer.createElement('script');
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${environment.GA_MEASUREMENT_ID}`;
    script1.async = true;
    this.renderer.appendChild(this.document.head, script1);

    const script2 = this.renderer.createElement('script');
    script2.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${environment.GA_MEASUREMENT_ID}');
    `;
    this.renderer.appendChild(this.document.head, script2);

  }
}

// 'linker': {
//   'domains': ['https://parceiros.homolog.pinpag.com.br']
// },
